import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "ThankYouModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "ThankYouModal",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content border-0 bg-transparent\"><div class=\"modal-body primary-gradient-bg bg-picado-img rounded-3 text-white text-center p-5\"><h5 class=\"fw-bolder mb-4\">Thank you<br> for joining Picado!</h5><p class=\"mb-4\">Now you can easily book your breakfast, lunch or dinner in advance whether you want to eat in or take it away.</p><a href=\"/restaurants\" class=\"btn btn-primary rounded-5 px-4 fw-bold me-2\">Let’s Begin</a></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}